import { useEffect, useState } from 'react';

import { isBase64, onDownloadFileFromServer } from 'utils';

import { isNilOrEmpty, isString } from 'ramda-adjunct';

export const useBlobFile = (
	file: string | File,
	output?: 'blob' | 'base64'
) => {
	const [filePath, setFilePath] = useState<string | null | undefined>('');

	useEffect(() => {
		if (isNilOrEmpty(file)) {
			setFilePath(null);
			return;
		}

		if (isString(file)) {
			if (isBase64(file)) {
				setFilePath(file);
			} else {
				(async () => {
					const src = (await onDownloadFileFromServer(file, '', {
						output,
						createObjectURL: true,
					})) as string;
					setFilePath(src);
				})();
			}
		} else {
			// Handle Blob/File type
			setFilePath(URL.createObjectURL(file));
		}
	}, [file]);

	return { filePath };
};
